// extracted by mini-css-extract-plugin
module.exports = {"wz06ft9":"wz06ft9","it9po97":"it9po97"};